import { render, staticRenderFns } from "./redpack.vue?vue&type=template&id=2f7b3ac0&scoped=true&"
import script from "./redpack.vue?vue&type=script&lang=js&"
export * from "./redpack.vue?vue&type=script&lang=js&"
import style0 from "./redpack.vue?vue&type=style&index=0&id=2f7b3ac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b3ac0",
  null
  
)

export default component.exports